var _effectorFileName = "/builds/gmini/front-ui-kit/src/Snackbar/Snackbar.tsx";
import { SnackbarContent } from 'notistack';
import { forwardRef } from 'react';
import { Wrapper, Message, InfoText, InfoIcon, InfoTextWrapper, CloseButton, Content } from './Snackbar.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Snackbar = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    id,
    message,
    infoText,
    onClose,
    color = 'info',
    ...other
  } = props;
  return /*#__PURE__*/_jsx(SnackbarContent, {
    ref: ref,
    role: "alert",
    ...other,
    children: /*#__PURE__*/_jsxs(Wrapper, {
      color: color,
      isSmall: !infoText,
      children: [/*#__PURE__*/_jsxs(Content, {
        children: [/*#__PURE__*/_jsx(Message, {
          children: message
        }), infoText && /*#__PURE__*/_jsxs(InfoTextWrapper, {
          children: [/*#__PURE__*/_jsx(InfoIcon, {}), /*#__PURE__*/_jsx(InfoText, {
            children: infoText
          })]
        })]
      }), /*#__PURE__*/_jsx(CloseButton, {
        color: "#fff",
        onClick: onClose
      })]
    })
  });
});
Snackbar.displayName = 'Snackbar';